"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _pay = _interopRequireDefault(require("../../../assets/images/pay.svg"));

var _success = _interopRequireDefault(require("../../../assets/images/success.svg"));

require("../styles/_pay-invoice.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PayInvoice = /*#__PURE__*/function (_Component) {
  _inherits(PayInvoice, _Component);

  var _super = _createSuper(PayInvoice);

  function PayInvoice(props) {
    var _this;

    _classCallCheck(this, PayInvoice);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_invoiceNumber", void 0);

    _defineProperty(_assertThisInitialized(_this), "handlePay", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var checkoutId, priceId, invoiceId, stripe, origin, _this$state, invoiceNumber, paymentAmount, invoiceBalance, paidInFullQuery, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                checkoutId = _ref.checkoutId, priceId = _ref.priceId, invoiceId = _ref.invoiceId;
                stripe = window.Stripe(checkoutId);
                origin = window.location.origin;
                _this$state = _this.state, invoiceNumber = _this$state.invoiceNumber, paymentAmount = _this$state.paymentAmount, invoiceBalance = _this$state.invoiceBalance;
                paidInFullQuery = invoiceBalance && paymentAmount === invoiceBalance.balance ? '&full=true' : '';
                _context.next = 7;
                return stripe.redirectToCheckout({
                  lineItems: [{
                    price: priceId,
                    quantity: 1
                  }],
                  mode: 'payment',
                  successUrl: "".concat(origin, "/finance/invoice/pay?number=").concat(invoiceNumber).concat(paidInFullQuery, "#success"),
                  cancelUrl: "".concat(origin, "/finance/invoice/pay?number=").concat(invoiceNumber, "#cancelled"),
                  clientReferenceId: invoiceId
                });

              case 7:
                result = _context.sent;

                if (result.error) {
                  (0, _commonReact.notify)({
                    type: 'error',
                    content: 'Something went wrong.'
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onChangeInput", function (e) {
      _this.setState({
        invoiceNumber: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onValidateInvoice", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state2, invoiceNumber, paymentAmount, getInvoice, _yield$getInvoice, data, error, _data$getInvoice, checkoutId, priceId, invoiceId;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state2 = _this.state, invoiceNumber = _this$state2.invoiceNumber, paymentAmount = _this$state2.paymentAmount;
              getInvoice = _this.props.getInvoice;

              _this.setState({
                busy: true
              });

              _context2.next = 5;
              return getInvoice({
                invoiceNumber: invoiceNumber,
                amount: paymentAmount
              });

            case 5:
              _yield$getInvoice = _context2.sent;
              data = _yield$getInvoice.data;
              error = _yield$getInvoice.error;

              _this.setState({
                busy: false
              });

              if (!error) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return");

            case 11:
              _this.setState({
                checkingOut: true
              });

              _data$getInvoice = data.getInvoice, checkoutId = _data$getInvoice.checkoutId, priceId = _data$getInvoice.priceId, invoiceId = _data$getInvoice.invoiceId;

              _this.handlePay({
                checkoutId: checkoutId,
                priceId: priceId,
                invoiceId: invoiceId
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var history = _this.props.history;
      history.push('/finance/invoice/pay');

      if (_this._invoiceNumber && _this._invoiceNumber.current) {
        _this._invoiceNumber.current.clearValue();
      }

      _this.setState({
        success: false,
        invoiceNumber: '',
        invoiceBalance: void 0,
        paymentType: 'FULL'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "makeAnotherPayment", function () {
      var invoiceNumber = _this.state.invoiceNumber;
      var history = _this.props.history;

      _this.reset();

      _this.setState({
        invoiceNumber: invoiceNumber
      });

      history.push("/finance/invoice/pay?number=".concat(invoiceNumber));
    });

    _defineProperty(_assertThisInitialized(_this), "getInvoiceBalance", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var invoiceNumber, _this$props, getInvoiceBalance, history, _yield$getInvoiceBala, data, error;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              invoiceNumber = _this.state.invoiceNumber;
              _this$props = _this.props, getInvoiceBalance = _this$props.getInvoiceBalance, history = _this$props.history;

              _this.setState({
                busy: true
              });

              _context3.next = 5;
              return getInvoiceBalance(invoiceNumber);

            case 5:
              _yield$getInvoiceBala = _context3.sent;
              data = _yield$getInvoiceBala.data;
              error = _yield$getInvoiceBala.error;

              _this.setState({
                busy: false
              });

              if (!error) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return");

            case 11:
              if (data.getInvoiceBalance) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return", void (0, _commonReact.notify)({
                content: 'There was a problem finding this invoice. Double check your invoice number.',
                type: 'error'
              }));

            case 13:
              if (!('balance' in data.getInvoiceBalance && !data.getInvoiceBalance.balance)) {
                _context3.next = 15;
                break;
              }

              return _context3.abrupt("return", void (0, _commonReact.notify)({
                content: 'This invoice has already been paid in full',
                type: 'success'
              }));

            case 15:
              _this.setState({
                invoiceBalance: data.getInvoiceBalance,
                paymentAmount: data.getInvoiceBalance.balance
              });

              history.push("?number=".concat(invoiceNumber));

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "changePaymentType", function (value) {
      return function () {
        _this.setState(function (_ref5) {
          var invoiceBalance = _ref5.invoiceBalance;
          return {
            paymentType: value,
            paymentAmount: invoiceBalance ? invoiceBalance.balance : 0
          };
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onChangePaymentAmount", function (e) {
      _this.setState({
        paymentAmount: parseFloat(e.target.value)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getPaymentAmountError", function () {
      var _this$state3 = _this.state,
          paymentAmount = _this$state3.paymentAmount,
          invoiceBalance = _this$state3.invoiceBalance;

      if (!invoiceBalance) {
        return '';
      }

      if (Number.isNaN(paymentAmount)) {
        return 'You must enter a valid number.';
      }

      if (paymentAmount > invoiceBalance.balance) {
        return 'You cannot pay more than the outstanding balance.';
      }

      if (paymentAmount <= 0) {
        return 'You have to pay a valid amount.';
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "renderPay", function () {
      var _this$state4 = _this.state,
          checkingOut = _this$state4.checkingOut,
          busy = _this$state4.busy,
          invoiceNumber = _this$state4.invoiceNumber,
          paymentType = _this$state4.paymentType,
          invoiceBalance = _this$state4.invoiceBalance;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "shootstacolour",
        size: 50
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading2: true
      }, "Pay for a Shootsta Invoice"), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        autoFocus: true,
        ref: _this._invoiceNumber,
        labelProps: {
          helper: invoiceBalance ? 'When you click \'Pay\' we\'ll redirect you to a secure checkout to pay for this invoice.' : 'When you click continue, we\'ll verify your invoice.',
          required: true
        },
        placeholder: "xxxxxxxxxxx",
        defaultValue: invoiceNumber,
        label: "Invoice Number",
        onChange: _this.onChangeInput,
        "data-testid": "invoice-number-input",
        disabled: Boolean(invoiceBalance)
      }), invoiceBalance ? /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content__left__invoice-info"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading3: true
      }, "This invoice has an outstanding balance of", /*#__PURE__*/_react.default.createElement("span", {
        className: "pay-invoice__container__content__left__invoice-info__currency"
      }, invoiceBalance.currency), /*#__PURE__*/_react.default.createElement("span", {
        className: "pay-invoice__container__content__left__invoice-info__balance"
      }, invoiceBalance.balance.toFixed(2)), "."), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "pay-invoice__container__content__left__invoice-info__pay-title",
        heading4: true
      }, "I want to pay:"), /*#__PURE__*/_react.default.createElement(_uiKit.RadioButton, {
        className: "pay-invoice__container__content__left__invoice-info__payment-type",
        onChange: _this.changePaymentType('FULL'),
        selected: paymentType === 'FULL',
        value: "FULL"
      }, "The full balance"), /*#__PURE__*/_react.default.createElement(_uiKit.RadioButton, {
        className: "pay-invoice__container__content__left__invoice-info__payment-type",
        onChange: _this.changePaymentType('PARTIAL'),
        selected: paymentType === 'PARTIAL',
        value: "PARTIAL"
      }, "Part of the balance"), paymentType === 'PARTIAL' ? /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        autoFocus: true,
        className: "pay-invoice__container__content__left__invoice-info__payment",
        label: "Amount",
        type: "number",
        defaultValue: invoiceBalance.balance.toFixed(2),
        prefix: /*#__PURE__*/_react.default.createElement("span", {
          className: "pay-invoice__container__content__left__invoice-info__payment__prefix"
        }, invoiceBalance.currency),
        errorMessage: _this.getPaymentAmountError(),
        onChange: _this.onChangePaymentAmount,
        validate: function validate() {
          return !_this.getPaymentAmountError();
        }
      }) : null) : null, invoiceBalance ? /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content__left__footer"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: _this.reset,
        type: "TERTIARY"
      }, "Pay For A Different Invoice"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: _this.onValidateInvoice,
        disabled: !invoiceNumber || checkingOut || _this.getPaymentAmountError(),
        busy: busy
      }, checkingOut ? 'Redirecting...' : 'Pay This Amount')) : /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: _this.getInvoiceBalance,
        disabled: !invoiceNumber,
        busy: busy
      }, "Continue"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        label: true,
        prefixIcon: "faq",
        noMargin: true
      }, "Any questions? Get in touch with your Account Manager."));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuccess", function () {
      var _this$state5 = _this.state,
          invoiceNumber = _this$state5.invoiceNumber,
          paidInFull = _this$state5.paidInFull;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content__left__success"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "shootstacolour",
        size: 50
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading2: true
      }, "Your payment was successful"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "You've paid ".concat(paidInFull ? 'off' : 'against', " the invoice ").concat(invoiceNumber, ".")), /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content__left__success__footer"
      }, paidInFull ? null : /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        onClick: _this.makeAnotherPayment
      }, "Make Another Payment"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: _this.reset
      }, "Pay for Another Invoice")));
    });

    var _props$location = props.location,
        hash = _props$location.hash,
        search = _props$location.search;

    var query = _queryString.default.parse(search);

    var queryNumber = query.number || '';

    var _paidInFull = query.full || '';

    _this.state = {
      invoiceNumber: Array.isArray(queryNumber) ? queryNumber[0] : queryNumber,
      busy: false,
      checkingOut: false,
      success: Boolean(hash && hash.substr(1) === 'success'),
      paidInFull: Boolean(Array.isArray(_paidInFull) ? _paidInFull[0] : _paidInFull),
      paymentType: 'FULL',
      paymentAmount: 0
    };
    _this._invoiceNumber = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  _createClass(PayInvoice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hash = this.props.location.hash;

      if (hash && hash.substr(1) === 'cancelled') {
        (0, _commonReact.notify)({
          type: 'warn',
          content: 'You cancelled the invoice payment. If you\'re having problems, get in touch.'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var success = this.state.success;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__content__left"
      }, success ? this.renderSuccess() : this.renderPay()), /*#__PURE__*/_react.default.createElement("div", {
        className: "pay-invoice__container__image-container"
      }, /*#__PURE__*/_react.default.createElement(_reactInlinesvg.default, {
        src: success ? _success.default : _pay.default,
        uniquifyIDs: true,
        title: "pay-graphic"
      }))));
    }
  }]);

  return PayInvoice;
}(_react.Component);

exports.default = PayInvoice;